import { render, staticRenderFns } from "./InstanceDropdown.vue?vue&type=template&id=cd64e440"
import script from "./InstanceDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstanceDropdown.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports